import { render } from "./KpsRegimeViolationsView.vue?vue&type=template&id=5f8a6140&scoped=true"
import script from "./KpsRegimeViolationsView.vue?vue&type=script&lang=js"
export * from "./KpsRegimeViolationsView.vue?vue&type=script&lang=js"

import "./KpsRegimeViolationsView.vue?vue&type=style&index=0&id=5f8a6140&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8a6140"]])

export default __exports__